import { render, staticRenderFns } from "./BorrarAbono.vue?vue&type=template&id=467c7a9e"
import script from "./BorrarAbono.vue?vue&type=script&setup=true&lang=js"
export * from "./BorrarAbono.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports